import { ESSENTIALS_CONTENT_CATEGORY } from '../../essentials/types'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** CIS Loss of Safety toolkit */
export const cisLossOfSafetyToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CIS_LOSS_OF_SAFETY,
  iFrameSrcUrl: '/loss-safety-cis-toolkit',
  micrositeUrl: 'loss-safety-cis-toolkit',
  title: {
    id: 'cisLossOfSafety.title',
    defaultMessage: 'Loss of Safety CIS toolkit',
    description: 'Microsite page title',
  },
  featureFlag: 'nov2025ToolkitsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
      params: {
        category: ESSENTIALS_CONTENT_CATEGORY.TOPIC,
        slug: 'coping-with-crisis',
      },
    },
  ],
  page: 'CIS loss of safety',
  trackUTMParams: {
    utm_campaign: 'CISlossofsafety',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'CISlossofsafety',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
}
